module.exports = __webpack_public_path__ + "media/images/icons/document-4e6a8746f2b60b9cfe397129c68dc5e2.svg";